import { createSelector, createSlice } from "@reduxjs/toolkit";

const INITIAL_STATE = {
  // cart items are placed here
  items: [],
  // only single merchant product items can be placed in cart at a time
  merchant: null,
  orderHashId: null,
  isSeen: true,
};

const cartSlice = createSlice({
  name: "cart",
  initialState: INITIAL_STATE,
  reducers: {
    addItem: (state, { payload }) => {
      state.items = payload;
      state.isSeen = false;
    },
    setItems: (state, { payload }) => {
      state.items = payload;
    },
    setMerchant: (state, { payload }) => {
      state.merchant = payload;
    },
    removeItem: (state, { payload }) => {
      state.items = payload;
    },
    resetCart: (state, { payload }) => {
      state.items = INITIAL_STATE.items;
      state.merchant = INITIAL_STATE.merchant;
    },
    setCartOrderId: (state, { payload }) => {
      state.orderHashId = payload;
    },
    setCartSeen: (state, { payload }) => {
      state.isSeen = payload;
    },
  },
});

export const cartReducer = cartSlice.reducer;

// Actions
export const {
  addItem,
  removeItem,
  setMerchant,
  setItems,
  resetCart,
  setCartOrderId,
  setCartSeen,
} = cartSlice.actions;

// Handler Functions for Cart
export const addItemToCart = (cartItems, item) => {
  if (item.quantity < 1) return removeFromCart(cartItems, item);

  // checking if the item is in the cart
  const found = cartItems.find(
    (product) => product.productId === item.productId
  );

  //   incrementing the product qty, if already in the cart
  if (found) {
    return cartItems.map((cartItem) =>
      cartItem.productId === item.productId
        ? { ...cartItem, quantity: item.quantity }
        : cartItem
    );
  }

  // returning the cart item to with new item added
  return [...cartItems, { ...item, quantity: item.quantity }];
};

export const hydrateCartOnLoad = (items) => {
  return items.map((item) => {
    return {
      ...item,
      title: item.productName,
      quantity: item.quantity,
      images: [{ imgPath: item.productImgPath }],
      id: parseInt(item.productId),
      driverDiscountedPrice: item.totalDiscountedPrice,
      merchantDetails: {
        merchantHashId: item.merchantHashId,
      },
    };
  });
};

export const removeFromCart = (cartItems = [], item) =>
  cartItems.filter((product) => product.productId !== item.productId);

export const isNewMerchant = (current, updated) => {
  if (!current) return false;
  return current !== updated;
};

export const getTotalItemsCountInCart = createSelector(
  (items) => items,
  (items) => {
    let total = 0;
    if (!items) return total;
    items.forEach((item) => {
      total = total + item.quantity;
    });
    return total;
  }
);

export default cartSlice;
